var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overall-priceAd-starts"},[_c('div',[_vm._l((_vm.scoreTypes),function(scoreType,index){return [_c('span',{key:index,class:_vm.scoreCls(scoreType)})]})],2),_c('em',[_vm._v(_vm._s(_vm.score.toFixed(2)))])])}
var staticRenderFns = []

export { render, staticRenderFns }